import { useEffect, useState } from "react";
import Tabs from "@/src/components/Tabs/Tabs";
import ApplyOnline from "../components/ApplyOnlinePage/ApplyOnline/ApplyOnline";
import ApplyOnlineCheck from "../components/ApplyOnlinePage/ApplyOnlineCheck/ApplyOnlineCheck";
import RedLineForTitle from "../components/RedLineForTitle/RedLineForTitle";

const ApplyTabs = [
  {
    id: "apply-online",
    name: "Заявка Онлайн",
  },
  {
    id: "apply-online-check",
    name: "Проверить статус заявки",
  },
];

const ApplyOnlinePage = () => {
  const [currentTab, setCurrentTab] = useState<string>("apply-online");

  useEffect(() => {
    const handleScroll = () => {
      const shouldBeFixed = window.scrollY / 16 > 5.4 && window.innerWidth > 768;

      const classNames = [".form-summary", ".apply-online-steps", ".apply-online-form"];

      classNames.forEach((selector) => {
        const elements = document.querySelectorAll<HTMLElement>(selector);
        elements.forEach((el) => {
          if (shouldBeFixed) {
            el.classList.add("fixed-apply");
          } else {
            el.classList.remove("fixed-apply");
          }
        });
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="apply-online-page container pages-margin-top">
      <RedLineForTitle title={"Подача заявки онлайн"} />
      <ApplyOnline />
      {/* <Tabs title="Подача заявки онлайн" tabs={ApplyTabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
      {currentTab === "apply-online" && <ApplyOnline />}
      {currentTab === "apply-online-check" && <ApplyOnlineCheck />} */}
    </section>
  );
};

export default ApplyOnlinePage;
